import { useMemo } from "react"
import type { PreOrderSmsMessage } from "@stockline/shared/types/orders/pre-order-sms-message"
import { PRE_ORDER_SMS_MESSAGE_TABLE } from "../../../lib/offline/resources/orders/pre-order-sms-message/db"
import { useAISync } from "../../ai/providers/AISyncProvider"

export interface UsePreOrderSmsMessagesFilter {
  preOrderId?: string
  messageId?: string
  smsChatId?: string
  includeDeleted?: boolean
}

export function usePreOrderSmsMessages(
  filter?: UsePreOrderSmsMessagesFilter
): PreOrderSmsMessage[] {
  const { reactive } = useAISync()
  const rows = reactive.useQuery<PreOrderSmsMessage>(
    PRE_ORDER_SMS_MESSAGE_TABLE,
    {
      ...(filter?.preOrderId ? { preOrderId: filter.preOrderId } : {}),
      ...(filter?.messageId ? { messageId: filter.messageId } : {}),
      ...(filter?.smsChatId ? { smsChatId: filter.smsChatId } : {}),
      orderBy: "-createdAt",
    }
  )
  // Memoize the filtered slice so the returned array reference stays stable
  // across renders when the underlying Dexie query is unchanged.
  const includeDeleted = filter?.includeDeleted === true
  return useMemo(
    () => (includeDeleted ? rows : rows.filter((r) => !r.deletedAt)),
    [rows, includeDeleted]
  )
}
